/**
 * 🤖 AUTO-GENERATED API SCHEMA FILE - DO NOT EDIT DIRECTLY!
 *
 * This file is automatically generated from entity configuration files.
 * Any manual changes will be lost when the generator runs again.
 *
 * 🔄 DATA FLOW PIPELINE:
 * 1. Entity Config (config/entities/user_profiles-entity-config.ts) → Single Source of Truth
 * 2. THIS FILE → TypeBox schemas for runtime validation + API types
 * 3. API Clients → Use these schemas for request/response validation
 * 4. React Hooks → Use these types for type-safe data fetching
 * 5. Components → Import types from this schema file
 *
 * 🛠️ TO MODIFY:
 * - Edit the entity config file: config/entities/user_profiles-entity-config.ts
 * - Run: npm run schemas:gen (regenerates this file)
 * - Or run: npm run db:full-workflow (does everything)
 *
 * 📋 ARCHITECTURE:
 * - Entity configs define field publicity, types, and validation rules
 * - TypeBox schemas provide runtime validation for API requests/responses
 * - Static types are derived from TypeBox schemas for compile-time safety
 * - Query options and response types standardize API interactions
 *
 * 🔗 RELATED FILES:
 * - config/entities/user_profiles-entity-config.ts (source configuration)
 * - scripts/generate-api-clients.ts (this generator)
 * - client/api/generated_clients/generated-user_profiles-api-client.ts (API client using these schemas)
 * - client/api/generated_hooks/user_profiles.ts (React hooks using these types)
 *
 * 🔒 SECURITY: Only fields marked as 'public: true' in the config are included
 *
 * Generated at: 2026-09-17T23:32:24.827Z
 * Source config: config/entities/user_profiles-entity-config.ts
 * Public fields: 27/29 total fields
 */

import { Type, Static } from '@sinclair/typebox';


// TypeBox schemas for runtime validation (public fields only)
export const UserProfilesSchema = Type.Object({
  id: Type.String({ format: "uuid" }), // id field
  first_name: Type.Union([Type.String(), Type.Null()]), // first_name field
  last_name: Type.Union([Type.String(), Type.Null()]), // last_name field
  phone: Type.Union([Type.String(), Type.Null()]), // phone field
  date_of_birth: Type.Union([Type.String(), Type.Null()]), // date_of_birth field
  gender: Type.Union([Type.String(), Type.Null()]), // gender field
  primary_email: Type.Union([Type.String(), Type.Null()]), // primary_email field
  custom_fields: Type.Union([Type.String(), Type.Null()]), // custom_fields field
  address1: Type.Union([Type.String(), Type.Null()]), // address1 field
  address2: Type.Union([Type.String(), Type.Null()]), // address2 field
  city: Type.Union([Type.String(), Type.Null()]), // city field
  state: Type.Union([Type.String(), Type.Null()]), // state field
  zip: Type.Union([Type.String(), Type.Null()]), // zip field
  display_first_name: Type.Union([Type.String(), Type.Null()]), // display_first_name field
  display_last_name: Type.Union([Type.String(), Type.Null()]), // display_last_name field
  created_by: Type.Union([Type.String(), Type.Null()]), // created_by field
  created_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // created_at field
  updated_by: Type.Union([Type.String(), Type.Null()]), // updated_by field
  updated_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // updated_at field
  terms_version_accepted: Type.Union([Type.String(), Type.Null()]), // terms_version_accepted field
  terms_accepted_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // terms_accepted_at field
  terms_accepted_ip: Type.Union([Type.String(), Type.Null()]), // terms_accepted_ip field
  is_active: Type.Boolean(), // is_active field
  deactivated_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // deactivated_at field
  deactivated_by_user_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // deactivated_by_user_id field
  deactivation_reason: Type.Union([Type.String(), Type.Null()]), // deactivation_reason field
  phone_digits: Type.Union([Type.String(), Type.Null()]), // phone_digits field
});

export const CreateUserProfilesSchema = Type.Object({
  first_name: Type.Union([Type.String(), Type.Null()]), // first_name field
  last_name: Type.Union([Type.String(), Type.Null()]), // last_name field
  phone: Type.Union([Type.String(), Type.Null()]), // phone field
  date_of_birth: Type.Union([Type.String(), Type.Null()]), // date_of_birth field
  gender: Type.Union([Type.String(), Type.Null()]), // gender field
  primary_email: Type.Union([Type.String(), Type.Null()]), // primary_email field
  custom_fields: Type.Optional(Type.Union([Type.String(), Type.Null()])), // custom_fields field
  address1: Type.Union([Type.String(), Type.Null()]), // address1 field
  address2: Type.Union([Type.String(), Type.Null()]), // address2 field
  city: Type.Union([Type.String(), Type.Null()]), // city field
  state: Type.Union([Type.String(), Type.Null()]), // state field
  zip: Type.Union([Type.String(), Type.Null()]), // zip field
  display_first_name: Type.Union([Type.String(), Type.Null()]), // display_first_name field
  display_last_name: Type.Union([Type.String(), Type.Null()]), // display_last_name field
  created_by: Type.Union([Type.String(), Type.Null()]), // created_by field
  updated_by: Type.Union([Type.String(), Type.Null()]), // updated_by field
  terms_version_accepted: Type.Union([Type.String(), Type.Null()]), // terms_version_accepted field
  terms_accepted_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // terms_accepted_at field
  terms_accepted_ip: Type.Union([Type.String(), Type.Null()]), // terms_accepted_ip field
  is_active: Type.Optional(Type.Boolean()), // is_active field
  deactivated_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // deactivated_at field
  deactivated_by_user_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // deactivated_by_user_id field
  deactivation_reason: Type.Union([Type.String(), Type.Null()]), // deactivation_reason field
  phone_digits: Type.Union([Type.String(), Type.Null()]), // phone_digits field
});

export const UpdateUserProfilesSchema = Type.Object({
  first_name: Type.Union([Type.String(), Type.Null()]), // first_name field
  last_name: Type.Union([Type.String(), Type.Null()]), // last_name field
  phone: Type.Union([Type.String(), Type.Null()]), // phone field
  date_of_birth: Type.Union([Type.String(), Type.Null()]), // date_of_birth field
  gender: Type.Union([Type.String(), Type.Null()]), // gender field
  primary_email: Type.Union([Type.String(), Type.Null()]), // primary_email field
  custom_fields: Type.Union([Type.String(), Type.Null()]), // custom_fields field
  address1: Type.Union([Type.String(), Type.Null()]), // address1 field
  address2: Type.Union([Type.String(), Type.Null()]), // address2 field
  city: Type.Union([Type.String(), Type.Null()]), // city field
  state: Type.Union([Type.String(), Type.Null()]), // state field
  zip: Type.Union([Type.String(), Type.Null()]), // zip field
  display_first_name: Type.Union([Type.String(), Type.Null()]), // display_first_name field
  display_last_name: Type.Union([Type.String(), Type.Null()]), // display_last_name field
  created_by: Type.Union([Type.String(), Type.Null()]), // created_by field
  updated_by: Type.Union([Type.String(), Type.Null()]), // updated_by field
  terms_version_accepted: Type.Union([Type.String(), Type.Null()]), // terms_version_accepted field
  terms_accepted_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // terms_accepted_at field
  terms_accepted_ip: Type.Union([Type.String(), Type.Null()]), // terms_accepted_ip field
  is_active: Type.Boolean(), // is_active field
  deactivated_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // deactivated_at field
  deactivated_by_user_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // deactivated_by_user_id field
  deactivation_reason: Type.Union([Type.String(), Type.Null()]), // deactivation_reason field
  phone_digits: Type.Union([Type.String(), Type.Null()]), // phone_digits field
});

// TypeScript types derived from TypeBox schemas (matching server-side pattern)
export type UserProfilesRow = Static<typeof UserProfilesSchema>;
export type UserProfilesInsert = Static<typeof CreateUserProfilesSchema>;
export type UserProfilesUpdate = Static<typeof UpdateUserProfilesSchema>;

// Legacy type aliases for backward compatibility
export type UserProfiles = UserProfilesRow;
export type CreateUserProfiles = UserProfilesInsert;
export type UpdateUserProfiles = Static<typeof UpdateUserProfilesSchema>;

// Field configuration metadata
export const UserProfilesFieldConfig = {
  filterable: ['id', 'deactivated_by_user_id'] as const,
  sortable: ['date_of_birth', 'created_at', 'updated_at'] as const,
  searchable: [] as const,
  required: ['id', 'is_active'] as const,
  readonly: ['id', 'created_at', 'updated_at'] as const,
} as const;
